import axios from 'axios';

let currentHash = ''; // require('package.json').version;
// let currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';
let hashChanged = false;
let newHash = '';

export const refreshPage = {

  methods: {

    startInterval(url: any, ClientVersion: string) {
      currentHash = ClientVersion;
      console.log(`in function with url ->${url} and version ->${ClientVersion}`);
      setInterval(() => {
        const baseUrl = window.location.origin;
        console.log(baseUrl);
        const env = !baseUrl.toLowerCase().includes('localhost');

        console.log(`Env -> ${env}`);
        if (env) {
          checkVersion(`${baseUrl}/ui/${url}`);
        } else {
          checkVersion(url);
        }
      }, 1000 * 60);
    },

  },
};

function checkVersion(url) {
  try {
    axios.get(`${url}?t=${new Date().getTime()}`).then((response) => {
      newHash = response.data.version;
      hashChanged = hasHashChanged(currentHash, newHash);
      const baseUrl = window.location.origin;
      //   console.log (baseUrl) ;
      //  var env = process.env.NODE_ENV === 'production' || 'ctd'  ?  true :false ;
      //  console.log("Env -> "+ env);
      //  if(env){
      if (!hashChanged) {
        reloadApp();
      }
      //     }
      console.log('true');
    }).catch((e) => {
      console.log(e);
    });
  } catch (error) {
    if (!error.response) {
      console.log(error);
    } else {
      console.log(error);
    }
  }
}

function hasHashChanged(currentHash, newHash) {
  console.log(`currentHash ->${currentHash} newHash ->${newHash}`);

  if (currentHash !== newHash) {
    // console.log ("false");
    return false;
  }
  // console.log ("true");
  return true;

  //   if (!currentHash || currentHash) {

  //     return true ;
  //   }

//  return currentHash !== newHash;
}

function reloadApp() {
  currentHash = newHash;
  window.location.reload();
}
